import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FakturniaHighlightComponent } from '@fakturnia/components/highlight';

@Component({
  selector: 'app-json-viewer',
  standalone: true,
  imports: [CommonModule, FakturniaHighlightComponent],
  templateUrl: './json-viewer.component.html',
  styleUrls: ['./json-viewer.component.scss']
})
export class JsonViewerComponent {
  @Input() json: any;
  @Input() maxHeight: string = '500px';

  get formattedJson(): string {
    if (!this.json) return '';
    return typeof this.json === 'string' 
      ? this.json 
      : JSON.stringify(this.json, null, 2);
  }
}

